export function isUnderBookLaw(book) {
    const publicationDate = book.subscriptionPublicationDate
        ? new Date(book.subscriptionPublicationDate)
        : book.publicationDate
            ? new Date(book.publicationDate)
            : null;
    if (!publicationDate) {
        return false;
    }
    const currentDate = new Date();
    const diffInYears = currentDate.getFullYear() - publicationDate.getFullYear();
    return diffInYears < 1;
}
